export const Bat = [
  {
    title: "Puma Evo Power 3 Cricket Bat",
    desc: "Puma Evo Power 3 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMEW05333701.jpg",
    currency: "INR ",
    price: "7999",
    mrp: "4799",
    discount: "40% off",
  },
  {
    title: "Puma Evo Speed 4 Cricket Bat",
    desc: "Puma Evo Speed 4 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMEW05334501.jpg",
    currency: "INR ",
    price: "8799",
    mrp: "5299",
    discount: "40% off",
  },
  {
    title: "Puma Evo Speed 7 Cricket Bat",
    desc: "Puma Evo Speed 7 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMEW05335801.jpg",
    currency: "INR ",
    price: "6999",
    mrp: "4199",
    discount: "40% off",
  },
  {
    title: "DSC Condor Pro Cricket Bat",
    desc: "DSC Condor Pro Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBCDPRO.jpg",
    currency: "INR ",
    price: "37749",
    mrp: "30199",
    discount: "20% off",
  },
  {
    title: "DSC Condor Patrol Cricket Bat",
    desc: "DSC Condor Patrol Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBCDPTRL.jpg",
    currency: "INR ",
    price: "22649",
    mrp: "18119",
    discount: "20% off",
  },
  {
    title: "DSC Condor Surge Cricket Bat",
    desc: "DSC Condor Surge Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBCDSRG.jpg",
    currency: "INR ",
    price: "19999",
    mrp: "15999",
    discount: "20% off",
  },
  {
    title: "DSC Condor Motion Cricket Bat",
    desc: "DSC Condor Motion Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBCDMTN.jpg",
    currency: "INR ",
    price: "11199",
    mrp: "8959",
    discount: "20% off",
  },
  {
    title: "DSC Intense Speed Cricket Bat",
    desc: "DSC Intense Speed Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBINSPD.jpg",
    currency: "INR ",
    price: "25299",
    mrp: "20239",
    discount: "20% off",
  },
  {
    title: "DSC Intense Pro Cricket Bat",
    desc: "DSC Intense Pro Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBINPRO.jpg",
    currency: "INR ",
    price: "37749",
    mrp: "30199",
    discount: "20% off",
  },
  {
    title: "DSC Intense Passion Cricket Bat",
    desc: "DSC Intense Passion Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBINPSN.jpg",
    currency: "INR ",
    price: "17379",
    mrp: "13903",
    discount: "20% off",
  },
  {
    title: "DSC Condor Glider Cricket Bat",
    desc: "DSC Condor Glider Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBCDGLDR.jpg",
    currency: "INR ",
    price: "14829",
    mrp: "11863",
    discount: "20% off",
  },
  {
    title: "DSC Condor Flite Cricket Bat",
    desc: "DSC Condor Flite Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBCDFLT.jpg",
    currency: "INR ",
    price: "30479",
    mrp: "24383",
    discount: "20% off",
  },
  {
    title: "DSC Intense Shoc Cricket Bat",
    desc: "DSC Intense Shoc Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBINSHOC.jpg",
    currency: "INR ",
    price: "12999",
    mrp: "10399",
    discount: "20% off",
  },
  {
    title: "DSC Intense Rage Cricket Bat",
    desc: "DSC Intense Rage Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBINRAGE.jpg",
    currency: "INR ",
    price: "10049",
    mrp: "8039",
    discount: "20% off",
  },
  {
    title: "DSC Vexer 100 Cricket Bat",
    desc: "DSC Vexer 100 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBV100.jpg",
    currency: "INR ",
    price: "6899",
    mrp: "5175",
    discount: "25% off",
  },
  {
    title: "DSC Vexer 200 Cricket Bat",
    desc: "DSC Vexer 200 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEBV200.jpg",
    currency: "INR ",
    price: "8999",
    mrp: "6749",
    discount: "25% off",
  },
  {
    title: "DSC Condor Atmos Cricket Bat",
    desc: "DSC Condor Atmos Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEB1030.jpg",
    currency: "INR ",
    price: "9049",
    mrp: "6799",
    discount: "25% off",
  },
  {
    title: "DSC Condor Drive Cricket Bat",
    desc: "DSC Condor Drive Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEB1031.jpg",
    currency: "INR ",
    price: "6899",
    mrp: "5175",
    discount: "25% off",
  },
  {
    title: "DSC Intense Attitude Cricket Bat",
    desc: "DSC Intense Attitude Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCEB1038.jpg",
    currency: "INR ",
    price: "8149",
    mrp: "6099",
    discount: "25% off",
  },
  {
    title: "GM Neon 303 Cricket Bat",
    desc: "GM Neon 303 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMGCEB1428.jpg",
    currency: "INR ",
    price: "6379",
    mrp: "5099",
    discount: "20% off",
  },
  {
    title: "GM Neon 333 Cricket Bat",
    desc: "GM Neon 333 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMGCEB1414.jpg",
    currency: "INR ",
    price: "7449",
    mrp: "5949",
    discount: "20% off",
  },
  {
    title: "SS Master Cricket Bat",
    desc: "SS Master Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWJRMS.jpg",
    currency: "INR ",
    price: "5220",
    mrp: "4200",
    discount: "20% off",
  },
  {
    title: "SS Master 5000 Cricket Bat",
    desc: "SS Master 5000 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWMS5000.jpg",
    currency: "INR ",
    price: "10800",
    mrp: "8640",
    discount: "20% off",
  },
  {
    title: "SS Ton Silver Edition Cricket Bat",
    desc: "SS Ton Silver Edition Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWTNSLED.jpg",
    currency: "INR ",
    price: "16200",
    mrp: "12150",
    discount: "25% off",
  },
  {
    title: "Adidas Libro League EW Cricket Bat",
    desc: "Adidas Libro League Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1220.jpg",
    currency: "INR ",
    price: "5599",
    mrp: "3649",
    discount: "35% off",
  },
  {
    title: "Adidas Pellara Leauge EW Cricket Bat",
    desc: "Adidas Pellara Leauge Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1483.jpg",
    currency: "INR ",
    price: "5599",
    mrp: "3649",
    discount: "35% off",
  },
  {
    title: "Adidas Pellara Mace EW Cricket Bat",
    desc: "Adidas Pellara Mace Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1484.jpg",
    currency: "INR ",
    price: "7999",
    mrp: "5199",
    discount: "35% off",
  },
  {
    title: "Adidas Pellara CX 11 EW Cricket Bat",
    desc: "Adidas Pellara CX 11 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1244.jpg",
    currency: "INR ",
    price: "5999",
    mrp: "3899",
    discount: "35% off",
  },
  {
    title: "Adidas Libro CX 11 EW Cricket Bat",
    desc: "Adidas Libro CX 11 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1213.jpg",
    currency: "INR ",
    price: "6299",
    mrp: "4099",
    discount: "35% off",
  },
  {
    title: "Adidas Pellara Club EW Cricket Bat",
    desc: "Adidas Pellara Club Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAB7376.jpg",
    currency: "INR ",
    price: "6999",
    mrp: "4549",
    discount: "35% off",
  },
  {
    title: "Adidas Libro Mace EW Cricket Bat",
    desc: "Adidas Libro Mace Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1223.jpg",
    currency: "INR ",
    price: "7599",
    mrp: "4949",
    discount: "35% off",
  },
  {
    title: "Adidas Libro Club EW Cricket Bat",
    desc: "Adidas Libro Club Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAB7381.jpg",
    currency: "INR ",
    price: "6999",
    mrp: "4549",
    discount: "35% off",
  },
  {
    title: "GM SIX6 F2 505 Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWS6F2404L.jpg",
    currency: "INR ",
    price: "9825",
    mrp: "8843",
    discount: "10% off",
  },
  {
    title: "GM SIX6 F2 707 Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWS6F2404L.jpg",
    currency: "INR ",
    price: "13825",
    mrp: "12443",
    discount: "10% off",
  },
  {
    title: "GM SIX6 F2 Excalibur Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWS6F2404L.jpg",
    currency: "INR ",
    price: "25499",
    mrp: "22949",
    discount: "10% off",
  },
  {
    title: "GM SIGMA F2 808 Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWSIGF2808L.jpg",
    currency: "INR ",
    price: "16025",
    mrp: "14423",
    discount: "10% off",
  },
  {
    title: "GM Aura F2 Excalibur Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWAUF2EXL.jpg",
    currency: "INR ",
    price: "25499",
    mrp: "22949",
    discount: "10% off",
  },
  {
    title: "SS Ton Rampage Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWCBTRP.jpg",
    currency: "INR ",
    price: "4500",
    mrp: "3600",
    discount: "20% off",
  },
  {
    title: "Kookaburra Menace 450 Cricket Bat",
    desc: "Kookaburra Menace 450 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/KBCREWM900L.jpg",
    currency: "INR ",
    price: "10999",
    mrp: "8799",
    discount: "20% off",
  },
  {
    title: "SS Ton Slasher Cricket Bat",
    desc: "The SS TON Slasher is a top class bat from SS with Super Grade 3 willow. The bat has massive SS TON edges and very light pickup. What's more, the Slasher has a huge playing area with perfect weight and good balance. The bat comes with an embossed chrome sticker with 3 Tone Scale Grip and a premium Carry bag. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWBTSLRL.jpg",
    currency: "INR ",
    price: "11160",
    mrp: "8928",
    discount: "20% off",
  },
  {
    title: "GM Neon 333 Cricket Bat",
    desc: "GM Neon 333 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMGCEB1414.jpg",
    currency: "INR ",
    price: "7449",
    mrp: "5949",
    discount: "20% off",
  },
  {
    title: "SS Master Cricket Bat",
    desc: "SS Master Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWJRMS.jpg",
    currency: "INR ",
    price: "5220",
    mrp: "4200",
    discount: "20% off",
  },
  {
    title: "SS Master 5000 Cricket Bat",
    desc: "SS Master 5000 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWMS5000.jpg",
    currency: "INR ",
    price: "10800",
    mrp: "8640",
    discount: "20% off",
  },
  {
    title: "SS Ton Silver Edition Cricket Bat",
    desc: "SS Ton Silver Edition Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWTNSLED.jpg",
    currency: "INR ",
    price: "16200",
    mrp: "12150",
    discount: "25% off",
  },
  {
    title: "Adidas Libro League EW Cricket Bat",
    desc: "Adidas Libro League Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1220.jpg",
    currency: "INR ",
    price: "5599",
    mrp: "3649",
    discount: "35% off",
  },
  {
    title: "Adidas Pellara Leauge EW Cricket Bat",
    desc: "Adidas Pellara Leauge Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1483.jpg",
    currency: "INR ",
    price: "5599",
    mrp: "3649",
    discount: "35% off",
  },
  {
    title: "Adidas Pellara Mace EW Cricket Bat",
    desc: "Adidas Pellara Mace Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1484.jpg",
    currency: "INR ",
    price: "7999",
    mrp: "5199",
    discount: "35% off",
  },
  {
    title: "Adidas Pellara CX 11 EW Cricket Bat",
    desc: "Adidas Pellara CX 11 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1244.jpg",
    currency: "INR ",
    price: "5999",
    mrp: "3899",
    discount: "35% off",
  },
  {
    title: "Adidas Libro CX 11 EW Cricket Bat",
    desc: "Adidas Libro CX 11 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1213.jpg",
    currency: "INR ",
    price: "6299",
    mrp: "4099",
    discount: "35% off",
  },
  {
    title: "Adidas Pellara Club EW Cricket Bat",
    desc: "Adidas Pellara Club Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAB7376.jpg",
    currency: "INR ",
    price: "6999",
    mrp: "4549",
    discount: "35% off",
  },
  {
    title: "Adidas Libro Mace EW Cricket Bat",
    desc: "Adidas Libro Mace Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAY1223.jpg",
    currency: "INR ",
    price: "7599",
    mrp: "4949",
    discount: "35% off",
  },
  {
    title: "Adidas Libro Club EW Cricket Bat",
    desc: "Adidas Libro Club Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADAB7381.jpg",
    currency: "INR ",
    price: "6999",
    mrp: "4549",
    discount: "35% off",
  },
  {
    title: "GM SIX6 F2 505 Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWS6F2404L.jpg",
    currency: "INR ",
    price: "9825",
    mrp: "8843",
    discount: "10% off",
  },
  {
    title: "GM SIX6 F2 707 Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWS6F2404L.jpg",
    currency: "INR ",
    price: "13825",
    mrp: "12443",
    discount: "10% off",
  },
  {
    title: "GM SIX6 F2 Excalibur Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWS6F2404L.jpg",
    currency: "INR ",
    price: "25499",
    mrp: "22949",
    discount: "10% off",
  },
  {
    title: "GM SIGMA F2 808 Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWSIGF2808L.jpg",
    currency: "INR ",
    price: "16025",
    mrp: "14423",
    discount: "10% off",
  },
  {
    title: "GM Aura F2 Excalibur Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWAUF2EXL.jpg",
    currency: "INR ",
    price: "25499",
    mrp: "22949",
    discount: "10% off",
  },
  {
    title: "SS Ton Rampage Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWCBTRP.jpg",
    currency: "INR ",
    price: "4500",
    mrp: "3600",
    discount: "20% off",
  },
  {
    title: "Kookaburra Menace 450 Cricket Bat",
    desc: "Kookaburra Menace 450 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/KBCREWM900L.jpg",
    currency: "INR ",
    price: "10999",
    mrp: "8799",
    discount: "20% off",
  },
  {
    title: "SS Ton Slasher Cricket Bat",
    desc: "The SS TON Slasher is a top class bat from SS with Super Grade 3 willow. The bat has massive SS TON edges and very light pickup. What's more, the Slasher has a huge playing area with perfect weight and good balance. The bat comes with an embossed chrome sticker with 3 Tone Scale Grip and a premium Carry bag. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWBTSLRL.jpg",
    currency: "INR ",
    price: "11160",
    mrp: "8928",
    discount: "20% off",
  },
  {
    title: "SS Ton Player Edition Cricket Bat",
    desc: "The SS TON Player Edition is a top class bat from SS with Super Grade 1 willow. The SS TON Player willow is air dried and exactly the same quality willow as used for top players. The bat has massive SS TON edges and very light pickup. What's more, the Player Edition bat has a huge playing area with perfect weight and good balance. The bat comes with an embossed chrome sticker with 3 Tone Scale Grip and a premium Carry bag. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "21600",
    mrp: "16200",
    discount: "25% off",
  },
  {
    title: "SS Ton Reserve Edition Cricket Bat",
    desc: "The SS TON Reserve Edition is a top class bat from SS with Super Grade 1 willow. The SS TON Reserve willow is air dried and exactly the same quality willow as used for top players. The bat has massive SS TON edges and very light pickup. What's more, the Reserve Edition bat has a huge playing area with perfect weight and good balance. The bat comes with an embossed chrome sticker with 3 Tone Scale Grip and a premium Carry bag. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "31500",
    mrp: "23625",
    discount: "25% off",
  },
  {
    title: "Cricket Bat Knocking In Service",
    desc: "\nCricket bats are made from willow which is fairly soft. Hence it is advisable to prepare the blade through the process of Knocking In so that it is ready to face the impact of high speed deliveries and to achieve optimal performance and longevity. In Knocking In, the bat goes through a process of oiling and hammer/ball knocks so as to make it ready to play.\nBats are NOT included in this Rs.500 service and you have to purchase them separately. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "500",
    mrp: "500",
    discount: "0% off",
  },
  {
    title: "Puma Karbon 4000 Cricket Bat",
    desc: "The Puma Karbon 4000 comes with bulk of the driving power in the blade towards the toe of the bat, combined with super thick edges, the result is a combination of pure power and balanced pick up. The blade is contoured precisely to remove any unnecessary weight from the bat without compromising performance or balance. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMCRBTKB4000L.jpg",
    currency: "INR ",
    price: "8999",
    mrp: "6299",
    discount: "30% off",
  },
  {
    title: "Puma Pulse 4000 Cricket Bat",
    desc: "\nThe Pulse 4000 is a bat with ultra modern design, lightweight construction and striking cosmetics, a perfect combination for the modern high impact players. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMCRBTPL4000L.jpg",
    currency: "INR ",
    price: "11999",
    mrp: "7199",
    discount: "40% off",
  },
  {
    title: "Kookaburra Recoil 650 Cricket Bat",
    desc: "Kookaburra Recoil 650 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/KBCRBTRC275L.jpg",
    currency: "INR ",
    price: "14999",
    mrp: "11999",
    discount: "20% off",
  },
  {
    title: "GM ARGON F2 DXM Original L.E. Cricket Bat",
    desc: "\nGunn & Moore english made bats are treated with GM DriGuard™, a water repellent solution applied to the toe of the bat to reduce the absorption of water. This helps prevent toe swelling, making the toe less susceptible to moisture induced damage. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWBTAF2L.jpg",
    currency: "INR ",
    price: "31925",
    mrp: "23944",
    discount: "25% off",
  },
  {
    title: "GM ARGON F2 505 Cricket Bat",
    desc: "\nMade from naturally seasoned bleached Grade 3 English willow. Minor knot marks with minor stain / speck. Fitted with good quality treble spring cane handle. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWBTAF2L.jpg",
    currency: "INR ",
    price: "8915",
    mrp: "6686",
    discount: "25% off",
  },
  {
    title: "SS KP Power 55 (Limited Edition) Cricket Bat",
    desc: "\nSS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWKPPWL.jpg",
    currency: "INR ",
    price: "14355",
    mrp: "11199",
    discount: "22% off",
  },
  {
    title: "SS Max Power Cricket Bat",
    desc: "\nSS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWMXPWL.jpg",
    currency: "INR ",
    price: "18150",
    mrp: "14157",
    discount: "22% off",
  },
  {
    title: "SS 309 Rock Cricket Bat",
    desc: "\nSS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEW309RL.jpg",
    currency: "INR ",
    price: "11220",
    mrp: "8415",
    discount: "25% off",
  },
  {
    title: "SS Magnum Cricket Bat",
    desc: "\nSS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSMagnum_L1.jpg",
    currency: "INR ",
    price: "2475",
    mrp: "1999",
    discount: "19% off",
  },
  {
    title: "SS Ranger Cricket Bat",
    desc: "\nSS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSRanger_L1.jpg",
    currency: "INR ",
    price: "10725",
    mrp: "8043",
    discount: "25% off",
  },
  {
    title: "SS Ton Matrix Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSMatrix_L1.jpg",
    currency: "INR ",
    price: "16500",
    mrp: "12869",
    discount: "22% off",
  },
  {
    title: "SS Gladiator Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSGladiator_L1.jpg",
    currency: "INR ",
    price: "27225",
    mrp: "20419",
    discount: "25% off",
  },
  {
    title: "SG Century Xtreme Cricket Bat",
    desc: "The Century Xtreme (Legend Series) is another classically styled bat. This bat has been designed to give you maximum control while playing strokes ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/sgcentury-xtreme_1200_1.jpg",
    currency: "INR ",
    price: "5499",
    mrp: "4399",
    discount: "20% off",
  },
  {
    title: "SG VS 319 Elite Cricket Bat",
    desc: "\nThe VS 319 Elite (Dasher Series) has been designed by the Nawab of Najafgarh Virender Sehwag himself ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/sgvs-319-elite_1200_1.jpg",
    currency: "INR ",
    price: "5499",
    mrp: "4399",
    discount: "20% off",
  },
  {
    title: "SG Stud T-20i Cricket Bat",
    desc: "Made for the born-to-attack batsman, the Stud T-20i (Aggressor Series) is the biggest of all SG bats. The bat has been designed from scratch for the Twenty20 format of the game. It has extra-thick edges and a massive profile, enhancing its exceptional power. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/sgstud-t20i_1200_1.jpg",
    currency: "INR ",
    price: "16999",
    mrp: "13599",
    discount: "20% off",
  },
  {
    title: "SG King Cobra Cricket Bat",
    desc: "\nLike playing attacking strokes? You'll love the King Cobra's (Aggressor Series) beautiful balance and weight. Made just for the aggressive batsmen, the bat packs exceptional power and has a lightweight pickup. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/sgking-cobra_1200_1.jpg",
    currency: "INR ",
    price: "16999",
    mrp: "13599",
    discount: "20% off",
  },
  {
    title: "SG Stud T-11i Cricket Bat",
    desc: "Made for the born-to-attack batsman, the Stud T-11i (Aggressor Series) is an affordable version of the T-20i. It is again one of the biggest bats in the range designed for the Twenty20 format of the game. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/sgstud-t11i_1200_1.jpg",
    currency: "INR ",
    price: "8999",
    mrp: "7199",
    discount: "20% off",
  },
  {
    title: "Kookaburra Blade 400 Cricket Bat",
    desc: "The lightweight BLADE gives you the speed and control to react. Its thick edges and high profile spine create a big hitting area.Ãƒâ€šÃ‚Â CHOOSE YOUR MOMENT TO STRIKE! ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/KBCRBTBL250L.jpg",
    currency: "INR ",
    price: "11499",
    mrp: "8969",
    discount: "22% off",
  },
  {
    title: "SG Reliant Xtreme Cricket Bat",
    desc: "The Reliant Xtreme (Legend Series) is a no frills traditional cricket bat. This classically styled bat, gives you maximum control during stroke play. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/sgreliant-xtreme_1200_1.jpg",
    currency: "INR ",
    price: "4499",
    mrp: "3599",
    discount: "20% off",
  },
  {
    title: "SG Nexus Xtreme Cricket Bat",
    desc: "The SG Nexus Xtreme (Legend Series) is an affordable yet powerful traditional cricket bat. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/sgnexus-xtreme_1200_1.jpg",
    currency: "INR ",
    price: "3699",
    mrp: "2959",
    discount: "20% off",
  },
  {
    title: "SS Torpedo Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSTorpedo_L1.jpg",
    currency: "INR ",
    price: "8829",
    mrp: "6887",
    discount: "22% off",
  },
  {
    title: "SS Ton Heritage Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSHeritage_L1.jpg",
    currency: "INR ",
    price: "7260",
    mrp: "5808",
    discount: "20% off",
  },
  {
    title: "SS Ton Orange Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSOrange_L1.jpg",
    currency: "INR ",
    price: "6930",
    mrp: "5544",
    discount: "20% off",
  },
  {
    title: "SS Supremo Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSSupremo.jpg",
    currency: "INR ",
    price: "5445",
    mrp: "4193",
    discount: "23% off",
  },
  {
    title: "SS Ton Custom Cricket Bat",
    desc: "\nSS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSCustom_L1.jpg",
    currency: "INR ",
    price: "3890",
    mrp: "3499",
    discount: "10% off",
  },
  {
    title: "SS Super Power Cricket Bat",
    desc: "\nSS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSSuperPower_L1.jpg",
    currency: "INR ",
    price: "4105",
    mrp: "3695",
    discount: "10% off",
  },
  {
    title: "SS Power Play Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWPOPLL.jpg",
    currency: "INR ",
    price: "3465",
    mrp: "2669",
    discount: "23% off",
  },
  {
    title: "SG T-45 Ultimate Cricket Bat",
    desc: "The SG T-45 Ultimate (Aggressor Series) Cricket Bat is made specially for the T-20 format of the game ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SGEWT45U1L.jpg",
    currency: "INR ",
    price: "15999",
    mrp: "12799",
    discount: "20% off",
  },
  {
    title: "SG T-45 Elite Cricket Bat",
    desc: "The SG T-45 Elite (Aggressor Series) Cricket Bat is made specially for the T-20 format of the game ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SGEWT45E1L.jpg",
    currency: "INR ",
    price: "13999",
    mrp: "11199",
    discount: "20% off",
  },
  {
    title: "SG VS-219 L.E. Cricket Bat",
    desc: "The VS 219 Limited Edition (Dasher Series) is a traditional bat with thick edges and a curved blade designed by the Nawab of Najafgarh Virender Sehwag himself ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SGEWVS219LE1L.jpg",
    currency: "INR ",
    price: "8999",
    mrp: "7199",
    discount: "20% off",
  },
  {
    title: "SG Super Cover Cricket Bat",
    desc: "The SG Super Cover (Legend Series) is an affordable yet powerful traditional cricket bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SGEWSUCV1L.jpg",
    currency: "INR ",
    price: "2499",
    mrp: "1999",
    discount: "20% off",
  },
  {
    title: "SS Blaster Cricket Bat",
    desc: "\nSS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SSEWBLL.jpg",
    currency: "INR ",
    price: "7290",
    mrp: "5686",
    discount: "22% off",
  },
  {
    title: "Puma Pulse 5000 Cricket Bat",
    desc: "\nThe Pulse 5000 is a bat with ultra modern deisgn, lightweight construction and striking cosmetics, a perfect combination for the modern high impact players. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMCREWPL5KL.jpg",
    currency: "INR ",
    price: "15999",
    mrp: "11199",
    discount: "30% off",
  },
  {
    title: "GM ARGON F2 909 Cricket Bat",
    desc: "\nThick edges for extra punch. Hand made for professional level and test level cricket players ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWBTAF2L.jpg",
    currency: "INR ",
    price: "17295",
    mrp: "12971",
    discount: "25% off",
  },
  {
    title: "GM ARGON F2 606 Cricket Bat",
    desc: "\nSuperior Seasoned bleached Grade 3 English Willow Fitted with good quality treble spring cane handle.\nDriGuard applied to resist damp and minimize toe swelling. Raw linseed oil applied to reduce cracking and splitting by maintaining the moisture level of the blade. Clear anti-scuff cover applied to the face and edges to increase blade durability. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWBTAF2L.jpg",
    currency: "INR ",
    price: "10725",
    mrp: "7999",
    discount: "25% off",
  },
  {
    title: "GM ARGON F2 303 Cricket Bat",
    desc: "\nSeasoned Grade 4 English Willow White Polycoat Finish Fitted with Protec™ cover to face and edges. ToeTek™ finish fitted as standard.\nToeTek Technology: Specially shaped resilient shield fitted to toe of bat. Reduces toe damage and feathering that is often caused by tapping at the crease. In also acts as a further barrier to damp. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWBTAF2L.jpg",
    currency: "INR ",
    price: "5995",
    mrp: "4796",
    discount: "20% off",
  },
  {
    title: "GM OCTANE F2 606 Cricket Bat",
    desc: "\nSuperior Seasoned bleached Grade 3 English Willow Fitted with good quality treble spring cane handle.\nDriGuard applied to resist damp and minimize toe swelling. Raw linseed oil applied to reduce cracking and splitting by maintaining the moisture level of the blade. Clear anti-scuff cover applied to the face and edges to increase blade durability. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GMEWBTOF2L.jpg",
    currency: "INR ",
    price: "10725",
    mrp: "8044",
    discount: "25% off",
  },
  {
    title: "GM OCTANE F2 505 Cricket Bat",
    desc: "\nMade from naturally seasoned bleached Grade 3 English willow. Minor knot marks with minor stain / speck. Fitted with good quality treble spring cane handle. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "8915",
    mrp: "6686",
    discount: "25% off",
  },
  {
    title: "Slazenger V360 Ultimate Cricket Bat",
    desc: " ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "20999",
    mrp: "14999",
    discount: "29% off",
  },
  {
    title: "Gray-Nicolls Powerbow GN7 Cricket Bat",
    desc: "Gray-Nicolls Powerbow GN7 Cricket Bat ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "13259",
    mrp: "9944",
    discount: "25% off",
  },
  {
    title: "SS Ton Gutsy Cricket Bat",
    desc: "The SS TON Gutsy is a top class bat from SS with Super Grade 4 willow. The bat has massive SS TON edges and very light pickup. What's more, the Gutsy has a huge playing area with perfect weight and good balance. The bat comes with an embossed chrome sticker with 3 Tone Scale Grip and a premium Carry bag. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "8100",
    mrp: "6075",
    discount: "25% off",
  },
  {
    title: "SS Ton Vertu Cricket Bat",
    desc: "The SS TON Vertu is a top class bat from SS with Super Grade 2 willow. The SS TON Vertu willow is exactly the same quality willow as used for top players. The bat has massive SS TON edges and very light pickup. What's more, the Vertu has a huge playing area with perfect weight and good balance. The bat comes with an embossed chrome sticker with 3 Tone Scale Grip and a premium Carry bag. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "11700",
    mrp: "8775",
    discount: "25% off",
  },
  {
    title: "Gray-Nicolls Powerbow GN5 Cricket Bat",
    desc: "Gray-Nicolls Powerbow GN5 Cricket Bat ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "10199",
    mrp: "7649",
    discount: "25% off",
  },
  {
    title: "GM OCTANE F2 707 Cricket Bat",
    desc: "Superior Seasoned unbleached Grade 2 English Willow Fitted with good quality treble spring cane handle.\nDriGuard applied to resist damp and minimize toe swelling. Raw linseed oil applied to reduce cracking and splitting by maintaining the moisture level of the blade. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "12545",
    mrp: "9409",
    discount: "25% off",
  },
  {
    title: "Kookaburra Recoil 700 Cricket Bat",
    desc: "Kookaburra Recoil 700 Cricket Bat ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "15999",
    mrp: "12799",
    discount: "20% off",
  },
  {
    title: "Kookaburra Recoil 400 Cricket Bat",
    desc: "Kookaburra Recoil 400 Cricket Bat ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "9999",
    mrp: "7999",
    discount: "20% off",
  },
  {
    title: "Kookaburra Kahuna 350 Cricket Bat",
    desc: "Kookaburra Kahuna 350 Cricket Bat ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "8999",
    mrp: "7199",
    discount: "20% off",
  },
  {
    title: "Kookaburra Menace Players Cricket Bat",
    desc: "Kookaburra Menace Players Cricket Bat ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "24999",
    mrp: "19999",
    discount: "20% off",
  },
  {
    title: "Kookaburra Menace 900 Cricket Bat",
    desc: "Kookaburra Menace 900 Cricket Bat ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "18999",
    mrp: "15199",
    discount: "20% off",
  },
  {
    title: "Kookaburra Menace 300 Cricket Bat",
    desc: "Kookaburra Menace 300 Cricket Bat ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "7999",
    mrp: "6399",
    discount: "20% off",
  },
  {
    title: "SS Ton Super Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "5400",
    mrp: "4320",
    discount: "20% off",
  },
  {
    title: "SS Ton Elite Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "4500",
    mrp: "3600",
    discount: "20% off",
  },
  {
    title: "SS Ton Blaser Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "5445",
    mrp: "4356",
    discount: "20% off",
  },
  {
    title: "SS Ton Blast Cricket Bat",
    desc: "SS Cricket Equipments are quality goods used by international players like Sachin Tendulkar, Virendar Sehwag, VVS Laxman among many others. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "5445",
    mrp: "4356",
    discount: "20% off",
  },
  {
    title: "Adidas Pellara Pro Cricket Bat",
    desc: "The adidas Pellara Pro English Willow bat for men is traditionally shaped and styled. It features the largest middle, thickest edges and has a balanced pick up. The Long middle swell & Balanced pick up with wider weight range along with Imported cane handle provides excellent shock absorption and gives jerk free performance. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "9599",
    mrp: "8639",
    discount: "10% off",
  },
  {
    title: "Adidas Pellara CX 11 Cricket Bat",
    desc: "The adidas Pellara CX 11 English Willow bat for men is traditionally shaped and styled. It features the largest middle, thickest edges and has a balanced pick up. The Long middle swell & Balanced pick up with wider weight range along with Imported cane handle provides excellent shock absorption and gives jerk free performance ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "7299",
    mrp: "6569",
    discount: "10% off",
  },
  {
    title: "Adidas Pellara League Cricket Bat",
    desc: "The adidas Pellara League Budget Priced English Willow bat for men is traditionally shaped and styled. It features the largest middle, thickest edges and has a balanced pick up. The Long middle swell & Balanced pick up with wider weight range along with Imported cane handle provides excellent shock absorption and gives jerk free performance. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "5499",
    mrp: "4949",
    discount: "10% off",
  },
  {
    title: "Puma Evo Power 2 Cricket Bat",
    desc: "Puma Evo Power 2 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMKW05336301.jpg",
    currency: "INR ",
    price: "1799",
    mrp: "1249",
    discount: "31% off",
  },
  {
    title: "Puma Evo Speed 5 Tennis Cricket Bat",
    desc: "Puma Evo Speed 5 Tennis Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMKW05336801.jpg",
    currency: "INR ",
    price: "1199",
    mrp: "899",
    discount: "25% off",
  },
  {
    title: "Puma Evo Speed 4 X Edge Cricket Bat",
    desc: "Puma Evo Speed 4 X Edge Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMKW05336701.jpg",
    currency: "INR ",
    price: "2999",
    mrp: "2099",
    discount: "30% off",
  },
  {
    title: "Puma Evo Speed 3 Cricket Bat",
    desc: "Puma Evo Speed 3 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMKW05336601.jpg",
    currency: "INR ",
    price: "1699",
    mrp: "1199",
    discount: "29% off",
  },
  {
    title: "Puma Evo Power 1 Cricket Bat",
    desc: "Puma Evo Power 1 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMKW05336001.jpg",
    currency: "INR ",
    price: "2399",
    mrp: "1699",
    discount: "29% off",
  },
  {
    title: "Puma Evo Speed 2 Cricket Bat",
    desc: "Puma Evo Speed 2 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMKW05336401.jpg",
    currency: "INR ",
    price: "1999",
    mrp: "1399",
    discount: "30% off",
  },
  {
    title: "Puma Evo Speed 6 Cricket Bat",
    desc: "Puma Evo Speed 6 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMKW05336101.jpg",
    currency: "INR ",
    price: "2199",
    mrp: "1549",
    discount: "30% off",
  },
  {
    title: "Puma Evo Speed 6 Cricket Bat",
    desc: "Puma Evo Speed 6 Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/PMKW05336501.jpg",
    currency: "INR ",
    price: "1699",
    mrp: "1199",
    discount: "29% off",
  },
  {
    title: "DSC Wildfire Inferno Tennis Cricket Bat",
    desc: "DSC Wildfire Inferno Tennis Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSC1500175.jpg",
    currency: "INR ",
    price: "1295",
    mrp: "1149",
    discount: "11% off",
  },
  {
    title: "DSC Wildfire Blaze Tennis Cricket Bat",
    desc: "DSC Wildfire Blaze Tennis Cricket Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=270,height=270,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCCKB3004.jpg",
    currency: "INR ",
    price: "1579",
    mrp: "1399",
    discount: "11% off",
  },
  {
    title: "DONIC Persson 500 Table Tennis Bat",
    desc: "DONIC Persson 500 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTB728451.jpg",
    currency: "INR ",
    price: "829",
    mrp: "750",
    discount: "10% off",
  },
  {
    title: "DONIC Persson 600 Table Tennis Bat",
    desc: "DONIC Persson 600 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTB728461.jpg",
    currency: "INR ",
    price: "1049",
    mrp: "950",
    discount: "9% off",
  },
  {
    title: "DONIC Young Champ 400 Table Tennis Bat",
    desc: "DONIC Young Champ 400 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTB705142.jpg",
    currency: "INR ",
    price: "699",
    mrp: "650",
    discount: "7% off",
  },
  {
    title: "DONIC Young Champ 300 Table Tennis Bat",
    desc: "DONIC Young Champ 300 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTB705132.jpg",
    currency: "INR ",
    price: "549",
    mrp: "500",
    discount: "9% off",
  },
  {
    title: "Butterfly Stayer 1200 Table Tennis Bat With 2 Balls",
    desc: "Butterfly Stayer 1200 Table Tennis Bat with 2 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTST1200.jpg",
    currency: "INR ",
    price: "2220",
    mrp: "1887",
    discount: "15% off",
  },
  {
    title: "Stag Power Drive Plus Table Tennis Bat",
    desc: "Stag Power Drive Plus Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTPD320.jpg",
    currency: "INR ",
    price: "1500",
    mrp: "1350",
    discount: "10% off",
  },
  {
    title: "Donic Waldner 5000 Table Tennis Bat",
    desc: "Donic Waldner 5000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTBAT751805.jpg",
    currency: "INR ",
    price: "4729",
    mrp: "3775",
    discount: "20% off",
  },
  {
    title: "Donic Carbotec 3000 Table Tennis Bat",
    desc: "Donic Carbotec 3000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTBAT758214.jpg",
    currency: "INR ",
    price: "5079",
    mrp: "4075",
    discount: "20% off",
  },
  {
    title: "Donic Carbotec 900 Table Tennis Bat",
    desc: "Donic Carbotec 900 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTBAT758212.jpg",
    currency: "INR ",
    price: "3999",
    mrp: "3199",
    discount: "20% off",
  },
  {
    title: "STAG Ninja Power Table Tennis Bat",
    desc: "STAG Ninja Power Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT362.jpg",
    currency: "INR ",
    price: "3700",
    mrp: "3330",
    discount: "10% off",
  },
  {
    title: "Stag Manika Batra MS20 Table Tennis Bat",
    desc: "Stag Manika Batra MS20 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS20.jpg",
    currency: "INR ",
    price: "360",
    mrp: "360",
    discount: "0% off",
  },
  {
    title: "Stag Manika Batra MS30 Table Tennis Bat",
    desc: "Stag Manika Batra MS30 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS30.jpg",
    currency: "INR ",
    price: "450",
    mrp: "450",
    discount: "0% off",
  },
  {
    title: "Stag Manika Batra MS40 Table Tennis Bat",
    desc: "Stag Manika Batra MS40 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS40.jpg",
    currency: "INR ",
    price: "550",
    mrp: "550",
    discount: "0% off",
  },
  {
    title: "Stag Manika Batra MS50 Table Tennis Bat",
    desc: "Stag Manika Batra MS50 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS50.jpg",
    currency: "INR ",
    price: "750",
    mrp: "675",
    discount: "10% off",
  },
  {
    title: "Stag Manika Batra MS3000 Table Tennis Bat",
    desc: "Stag Manika Batra MS3000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS3000.jpg",
    currency: "INR ",
    price: "1100",
    mrp: "950",
    discount: "14% off",
  },
  {
    title: "STAG Super Table Tennis Bat",
    desc: "STAG Super Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT330.jpg",
    currency: "INR ",
    price: "700",
    mrp: "600",
    discount: "14% off",
  },
  {
    title: "STAG International Table Tennis Bat (With Wooden Case)",
    desc: "\nHigh Quality Table Tennis Racquets. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT321_L.jpg",
    currency: "INR ",
    price: "1350",
    mrp: "1150",
    discount: "15% off",
  },
  {
    title: "STAG Power Drive Table Tennis Bat (With Wooden Case)",
    desc: "ITTF Approved Power Drive Rubber. ALL-ROUND Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT320_L.jpg",
    currency: "INR ",
    price: "1650",
    mrp: "1400",
    discount: "15% off",
  },
  {
    title: "DONIC Epox Off Sonex JP Gold Table Tennis Bat",
    desc: "DONIC Epox Off Sonex JP Gold Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DNDTBEOSJG.jpg",
    currency: "INR ",
    price: "10899",
    mrp: "8174",
    discount: "25% off",
  },
  {
    title: "Butterfly Timo Boll 2000 Table Tennis Bat",
    desc: "\nButterfly Timo Boll 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTB2000L.jpg",
    currency: "INR ",
    price: "2390",
    mrp: "1999",
    discount: "16% off",
  },
  {
    title: "Butterfly Addoy 2000 Table Tennis Bat",
    desc: "\nButterfly Addoy 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTA2000L.jpg",
    currency: "INR ",
    price: "1580",
    mrp: "1349",
    discount: "15% off",
  },
  {
    title: "DONIC Waldner 3000 Table Tennis Bat",
    desc: "\nLevel 3000 attack+ racket. Flared (FL) handle. Inverted Liga rubber with 2.3 mm sponge. Carbon blade featuring ABP (Adjustable Balance Point) and Ergo Grip. ITTF approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DNTTBTWL3K.jpg",
    currency: "INR ",
    price: "4549",
    mrp: "3649",
    discount: "20% off",
  },
  {
    title: "Nittaku Brave 300 Table Tennis Bat",
    desc: "\nNittaku Brave 300 is designed for Perfect Control with Speed. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NTTTBTBV300.jpg",
    currency: "INR ",
    price: "825",
    mrp: "619",
    discount: "25% off",
  },
  {
    title: "Nittaku Brave 100 Table Tennis Bat",
    desc: "\nNittaku Brave 100 is designed for Control with Speed. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NTTTBTBV100.jpg",
    currency: "INR ",
    price: "725",
    mrp: "544",
    discount: "25% off",
  },
  {
    title: "STAG One Star Play Table Tennis Bat Set",
    desc: "\nPlay Set: 2 Bats , 3 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT329.jpg",
    currency: "INR ",
    price: "520",
    mrp: "475",
    discount: "9% off",
  },
  {
    title: "STAG 1 Star Table Tennis Bat",
    desc: "Racquet for Fun Play and Beginners. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT351_L.jpg",
    currency: "INR ",
    price: "200",
    mrp: "200",
    discount: "0% off",
  },
  {
    title: "STAG Play Table Tennis Bat Set",
    desc: "Play Set: 2 Bats , 3 Balls, PVC Net ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT328.jpg",
    currency: "INR ",
    price: "650",
    mrp: "575",
    discount: "12% off",
  },
  {
    title: "STAG 3 Star Table Tennis Bat",
    desc: "Racquet for School level players. Good all round racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT353_L.jpg",
    currency: "INR ",
    price: "520",
    mrp: "475",
    discount: "9% off",
  },
  {
    title: "STAG 2 Star Table Tennis Bat",
    desc: "Racquet for Beginners. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT352_L.jpg",
    currency: "INR ",
    price: "275",
    mrp: "275",
    discount: "0% off",
  },
  {
    title: "STAG 4 Star Table Tennis Bat",
    desc: "Racquet for School level players. Excellent control, fast racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT354_L.jpg",
    currency: "INR ",
    price: "575",
    mrp: "525",
    discount: "9% off",
  },
  {
    title: "STAG Club Table Tennis Bat",
    desc: "Good Control Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT325_L.jpg",
    currency: "INR ",
    price: "350",
    mrp: "325",
    discount: "7% off",
  },
  {
    title: "STAG 5 Star Table Tennis Bat",
    desc: "\nIdeal racquet for serious learners who want to play competitive table tennis. Fast racquet with very good Spin. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT355_L.jpg",
    currency: "INR ",
    price: "775",
    mrp: "650",
    discount: "16% off",
  },
  {
    title: "STAG Official Table Tennis Bat",
    desc: "\nGood Control Racquet. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT323_M1.jpg",
    currency: "INR ",
    price: "900",
    mrp: "800",
    discount: "11% off",
  },
  {
    title: "STAG Tourtitlent Table Tennis Bat",
    desc: "\nGood Control Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT324_L.jpg",
    currency: "INR ",
    price: "475",
    mrp: "425",
    discount: "11% off",
  },
  {
    title: "STAG Championship Table Tennis Bat",
    desc: "\nHigh Quality Table Tennis Racquets. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT322_M1.jpg",
    currency: "INR ",
    price: "1100",
    mrp: "925",
    discount: "16% off",
  },
  {
    title: "STAG Ninja Attack Table Tennis Bat",
    desc: "ITTF Approved Ninja Attack Rubber. Excellent Spin. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT333_L.jpg",
    currency: "INR ",
    price: "1950",
    mrp: "1650",
    discount: "15% off",
  },
  {
    title: "STAG All Round Table Tennis Bat",
    desc: "\nITTF Approved Rubber. Perfect racquet for All-round play! ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT318_L.jpg",
    currency: "INR ",
    price: "2300",
    mrp: "1950",
    discount: "15% off",
  },
  {
    title: "STAG Ninja Fire Table Tennis Bat",
    desc: "ITTF Approved. Excellent Racquet for very fast shots & great spin! ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT326_L.jpg",
    currency: "INR ",
    price: "2500",
    mrp: "2125",
    discount: "15% off",
  },
  {
    title: "DONIC Waldner 400 Table Tennis Bat",
    desc: "\nWaldner 400: For an allround game with outstanding control ! Elite 1 Star ITTF approved reversed rubber . Flared handle and with 1.8 mm Donic red and black rubber sheets. With Anti Vibration System. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W400_L.jpg",
    currency: "INR ",
    price: "649",
    mrp: "599",
    discount: "8% off",
  },
  {
    title: "DONIC Waldner 1000 Table Tennis Bat",
    desc: "\nTop of the line Carbon racquet !\nA 3-ply wood and 2 Ply carbon and Adjustable Balance Point in the handle. Comes with 2.1 mm Liga red and black rubber (ITTF approved).  ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W1000_L.jpg",
    currency: "INR ",
    price: "3449",
    mrp: "2749",
    discount: "20% off",
  },
  {
    title: "Butterfly Addoy 2000 Table Tennis Bat",
    desc: "\nButterfly Addoy 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTA2000L.jpg",
    currency: "INR ",
    price: "1580",
    mrp: "1349",
    discount: "15% off",
  },
  {
    title: "DONIC Waldner 3000 Table Tennis Bat",
    desc: "\nLevel 3000 attack+ racket. Flared (FL) handle. Inverted Liga rubber with 2.3 mm sponge. Carbon blade featuring ABP (Adjustable Balance Point) and Ergo Grip. ITTF approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DNTTBTWL3K.jpg",
    currency: "INR ",
    price: "4549",
    mrp: "3649",
    discount: "20% off",
  },
  {
    title: "Nittaku Brave 300 Table Tennis Bat",
    desc: "\nNittaku Brave 300 is designed for Perfect Control with Speed. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NTTTBTBV300.jpg",
    currency: "INR ",
    price: "825",
    mrp: "619",
    discount: "25% off",
  },
  {
    title: "Nittaku Brave 100 Table Tennis Bat",
    desc: "\nNittaku Brave 100 is designed for Control with Speed. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/NTTTBTBV100.jpg",
    currency: "INR ",
    price: "725",
    mrp: "544",
    discount: "25% off",
  },
  {
    title: "STAG One Star Play Table Tennis Bat Set",
    desc: "\nPlay Set: 2 Bats , 3 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT329.jpg",
    currency: "INR ",
    price: "520",
    mrp: "475",
    discount: "9% off",
  },
  {
    title: "STAG 1 Star Table Tennis Bat",
    desc: "Racquet for Fun Play and Beginners. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT351_L.jpg",
    currency: "INR ",
    price: "200",
    mrp: "200",
    discount: "0% off",
  },
  {
    title: "STAG Play Table Tennis Bat Set",
    desc: "Play Set: 2 Bats , 3 Balls, PVC Net ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT328.jpg",
    currency: "INR ",
    price: "650",
    mrp: "575",
    discount: "12% off",
  },
  {
    title: "STAG 3 Star Table Tennis Bat",
    desc: "Racquet for School level players. Good all round racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT353_L.jpg",
    currency: "INR ",
    price: "520",
    mrp: "475",
    discount: "9% off",
  },
  {
    title: "STAG 2 Star Table Tennis Bat",
    desc: "Racquet for Beginners. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT352_L.jpg",
    currency: "INR ",
    price: "275",
    mrp: "275",
    discount: "0% off",
  },
  {
    title: "STAG 4 Star Table Tennis Bat",
    desc: "Racquet for School level players. Excellent control, fast racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT354_L.jpg",
    currency: "INR ",
    price: "575",
    mrp: "525",
    discount: "9% off",
  },
  {
    title: "STAG Club Table Tennis Bat",
    desc: "Good Control Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT325_L.jpg",
    currency: "INR ",
    price: "350",
    mrp: "325",
    discount: "7% off",
  },
  {
    title: "STAG 5 Star Table Tennis Bat",
    desc: "\nIdeal racquet for serious learners who want to play competitive table tennis. Fast racquet with very good Spin. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT355_L.jpg",
    currency: "INR ",
    price: "775",
    mrp: "650",
    discount: "16% off",
  },
  {
    title: "STAG Official Table Tennis Bat",
    desc: "\nGood Control Racquet. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT323_M1.jpg",
    currency: "INR ",
    price: "900",
    mrp: "800",
    discount: "11% off",
  },
  {
    title: "STAG Tourtitlent Table Tennis Bat",
    desc: "\nGood Control Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT324_L.jpg",
    currency: "INR ",
    price: "475",
    mrp: "425",
    discount: "11% off",
  },
  {
    title: "STAG Championship Table Tennis Bat",
    desc: "\nHigh Quality Table Tennis Racquets. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT322_M1.jpg",
    currency: "INR ",
    price: "1100",
    mrp: "925",
    discount: "16% off",
  },
  {
    title: "STAG Ninja Attack Table Tennis Bat",
    desc: "ITTF Approved Ninja Attack Rubber. Excellent Spin. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT333_L.jpg",
    currency: "INR ",
    price: "1950",
    mrp: "1650",
    discount: "15% off",
  },
  {
    title: "STAG All Round Table Tennis Bat",
    desc: "\nITTF Approved Rubber. Perfect racquet for All-round play! ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT318_L.jpg",
    currency: "INR ",
    price: "2300",
    mrp: "1950",
    discount: "15% off",
  },
  {
    title: "STAG Ninja Fire Table Tennis Bat",
    desc: "ITTF Approved. Excellent Racquet for very fast shots & great spin! ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT326_L.jpg",
    currency: "INR ",
    price: "2500",
    mrp: "2125",
    discount: "15% off",
  },
  {
    title: "DONIC Waldner 400 Table Tennis Bat",
    desc: "\nWaldner 400: For an allround game with outstanding control ! Elite 1 Star ITTF approved reversed rubber . Flared handle and with 1.8 mm Donic red and black rubber sheets. With Anti Vibration System. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W400_L.jpg",
    currency: "INR ",
    price: "649",
    mrp: "599",
    discount: "8% off",
  },
  {
    title: "DONIC Waldner 1000 Table Tennis Bat",
    desc: "\nTop of the line Carbon racquet !\nA 3-ply wood and 2 Ply carbon and Adjustable Balance Point in the handle. Comes with 2.1 mm Liga red and black rubber (ITTF approved).  ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W1000_L.jpg",
    currency: "INR ",
    price: "3449",
    mrp: "2749",
    discount: "20% off",
  },
  {
    title: "DONIC Waldner 800 Table Tennis Bat",
    desc: "\nWaldner 800: Allows sophisticated play with optimum speed and relatively high spin! \nA very controlled ITTF-approved rubber sheet with a 5-ply allround plywood and a Senso grip and 2.1 mm Alpha Slick rubber gives you a superior feeling for the ball in all playing situations.  ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W800_L.jpg",
    currency: "INR ",
    price: "2229",
    mrp: "1675",
    discount: "25% off",
  },
  {
    title: "DONIC Waldner 700 Table Tennis Bat",
    desc: "\nWaldner 700: For advanced playing techniques with very good spin and speed! With concave handle and with Vari Slick 2.0 mm rubber (ITTF approved). ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W700_L.jpg",
    currency: "INR ",
    price: "1729",
    mrp: "1375",
    discount: "20% off",
  },
  {
    title: "DONIC Waldner 600 Table Tennis Bat",
    desc: "\nWaldner 600: Controllable All-round racquet comes with 2.0 mm soft red and black rubber with 5-plywood. Avantgarde 3 Star reversed rubber (ITTF approved). ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W600_L.jpg",
    currency: "INR ",
    price: "1179",
    mrp: "1000",
    discount: "15% off",
  },
  {
    title: "DONIC Waldner 500 Table Tennis Bat",
    desc: "\nWaldner 500: Controllable All-round rubber. The racquet comes with 1.8 mm soft red and black 2 star rubber in combination with the 5-ply allround plywood.\nWith Power Light System. Suitable for advanced play with good ball control. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W500_L.jpg",
    currency: "INR ",
    price: "829",
    mrp: "750",
    discount: "10% off",
  },
  {
    title: "DONIC Waldner 900 Table Tennis Bat",
    desc: "\nAllows sophisticated play with optimum speed and relatively high spin! \nA 5-ply wood which comes with 2.1 mm red and black Easy Slick rubber and a Flared handle. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W900_L.jpg",
    currency: "INR ",
    price: "2999",
    mrp: "2249",
    discount: "25% off",
  },
  {
    title: "Stiga Elite Table Tennis Bat",
    desc: "The ELITE combines spin and speed characteristics for the serious player.Â WRB technology provides extra sensitivity and more power.Â Â WRB Patented System.Â Â I.T.T.F. Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STTTBTEL.jpg",
    currency: "INR ",
    price: "940",
    mrp: "752",
    discount: "20% off",
  },
  {
    title: "STAG Power Drive Table Tennis Bat",
    desc: "ITTF Approved Power Drive Rubber. ALL-ROUND Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT320_L.jpg",
    currency: "INR ",
    price: "1450",
    mrp: "1225",
    discount: "16% off",
  },
  {
    title: "STAG International Table Tennis Bat",
    desc: "\nHigh Quality Table Tennis Racquets. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT321_L.jpg",
    currency: "INR ",
    price: "1150",
    mrp: "975",
    discount: "15% off",
  },
  {
    title: "DONIC Gold Attack Table Tennis Bat",
    desc: "\nGOLD Attack: Endorsed by Jan-Ove Waldner. For the sophisticated play of all techniques with spin and high speed.\nWith shock absorbing layers, AVS offers less vibration and more control. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GOLD_L.jpg",
    currency: "INR ",
    price: "1379",
    mrp: "1249",
    discount: "9% off",
  },
  {
    title: "Butterfly Wakaba 20 With 2 Balls",
    desc: "Butterfly Wakaba 20 with 2 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTSTW20L.jpg",
    currency: "INR ",
    price: "2180",
    mrp: "1635",
    discount: "25% off",
  },
  {
    title: "Butterfly Stayer With 2 Balls",
    desc: "Butterfly Stayer with 2 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTSTSTL.jpg",
    currency: "INR ",
    price: "3721",
    mrp: "2605",
    discount: "30% off",
  },
  {
    title: "Butterfly Addoy 1000 Table Tennis Bat",
    desc: "Butterfly Addoy 1000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTA1000L.jpg",
    currency: "INR ",
    price: "1580",
    mrp: "1349",
    discount: "15% off",
  },
  {
    title: "Butterfly Wakaba 1000 Table Tennis Bat",
    desc: "\nButterfly Wakaba 1000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTWK1000L.jpg",
    currency: "INR ",
    price: "2240",
    mrp: "1899",
    discount: "15% off",
  },
  {
    title: "Butterfly Wakaba 2000 Table Tennis Bat",
    desc: "\nButterfly Wakaba 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTWK2000L.jpg",
    currency: "INR ",
    price: "2240",
    mrp: "1899",
    discount: "15% off",
  },
  {
    title: "Butterfly Timo Boll 1000 Table Tennis Bat",
    desc: "\nButterfly Timo Boll 1000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTB1000.jpg",
    currency: "INR ",
    price: "2390",
    mrp: "1999",
    discount: "16% off",
  },
  {
    title: "Butterfly Timo Boll CF 1000 Table Tennis Bat",
    desc: "\nButterfly Timo Boll CF 1000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTBCF1000L.jpg",
    currency: "INR ",
    price: "3820",
    mrp: "2675",
    discount: "30% off",
  },
  {
    title: "Butterfly Timo Boll CF 2000 Table Tennis Bat",
    desc: "Butterfly Timo Boll CF 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTBCF2000L.jpg",
    currency: "INR ",
    price: "3820",
    mrp: "2675",
    discount: "30% off",
  },
  {
    title: "STAG Peter Fire Ninja Table Tennis Bat",
    desc: "STAG Peter Fire Ninja Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTPTFR.jpg",
    currency: "INR ",
    price: "5200",
    mrp: "4150",
    discount: "20% off",
  },
  {
    title: "Stag Manika Batra MS10 Table Tennis Bat",
    desc: "Stag Manika Batra MS10 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS10.jpg",
    currency: "INR ",
    price: "250",
    mrp: "250",
    discount: "0% off",
  },
  {
    title: "Stag Manika Batra MS2000 Table Tennis Bat",
    desc: "Stag Manika Batra MS2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS2000.jpg",
    currency: "INR ",
    price: "900",
    mrp: "810",
    discount: "10% off",
  },
  {
    title: "Donic Carbotec 7000 Table Tennis Bat",
    desc: "Donic Carbotec 7000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTBAT758216.jpg",
    currency: "INR ",
    price: "5379",
    mrp: "4299",
    discount: "20% off",
  },
  {
    title: "Butterfly Stayer 1800 Table Tennis Bat",
    desc: "Butterfly Stayer 1800 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTST1800.jpg",
    currency: "INR ",
    price: "2570",
    mrp: "1799",
    discount: "30% off",
  },
  {
    title: "Butterfly Stayer 3000 Table Tennis Bat",
    desc: "Butterfly Stayer 3000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTST3000.jpg",
    currency: "INR ",
    price: "2990",
    mrp: "2541",
    discount: "15% off",
  },
  {
    title: "Butterfly Timo Boll 3000 Table Tennis Bat With 2 Balls",
    desc: "Butterfly Timo Boll 3000 Table Tennis Bat with 2 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTB3000W2B.jpg",
    currency: "INR ",
    price: "2390",
    mrp: "1999",
    discount: "16% off",
  },
  {
    title: "DONIC Persson 500 Table Tennis Bat",
    desc: "DONIC Persson 500 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTB728451.jpg",
    currency: "INR ",
    price: "829",
    mrp: "750",
    discount: "10% off",
  },
  {
    title: "DONIC Persson 600 Table Tennis Bat",
    desc: "DONIC Persson 600 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTB728461.jpg",
    currency: "INR ",
    price: "1049",
    mrp: "950",
    discount: "9% off",
  },
  {
    title: "DONIC Young Champ 400 Table Tennis Bat",
    desc: "DONIC Young Champ 400 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTB705142.jpg",
    currency: "INR ",
    price: "699",
    mrp: "650",
    discount: "7% off",
  },
  {
    title: "DONIC Young Champ 300 Table Tennis Bat",
    desc: "DONIC Young Champ 300 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTB705132.jpg",
    currency: "INR ",
    price: "549",
    mrp: "500",
    discount: "9% off",
  },
  {
    title: "Butterfly Stayer 1200 Table Tennis Bat With 2 Balls",
    desc: "Butterfly Stayer 1200 Table Tennis Bat with 2 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTST1200.jpg",
    currency: "INR ",
    price: "2220",
    mrp: "1887",
    discount: "15% off",
  },
  {
    title: "Stag Power Drive Plus Table Tennis Bat",
    desc: "Stag Power Drive Plus Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTPD320.jpg",
    currency: "INR ",
    price: "1500",
    mrp: "1350",
    discount: "10% off",
  },
  {
    title: "Donic Waldner 5000 Table Tennis Bat",
    desc: "Donic Waldner 5000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTBAT751805.jpg",
    currency: "INR ",
    price: "4729",
    mrp: "3775",
    discount: "20% off",
  },
  {
    title: "Donic Carbotec 3000 Table Tennis Bat",
    desc: "Donic Carbotec 3000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTBAT758214.jpg",
    currency: "INR ",
    price: "5079",
    mrp: "4075",
    discount: "20% off",
  },
  {
    title: "Donic Carbotec 900 Table Tennis Bat",
    desc: "Donic Carbotec 900 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTBAT758212.jpg",
    currency: "INR ",
    price: "3999",
    mrp: "3199",
    discount: "20% off",
  },
  {
    title: "STAG Ninja Power Table Tennis Bat",
    desc: "STAG Ninja Power Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT362.jpg",
    currency: "INR ",
    price: "3700",
    mrp: "3330",
    discount: "10% off",
  },
  {
    title: "Stag Manika Batra MS20 Table Tennis Bat",
    desc: "Stag Manika Batra MS20 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS20.jpg",
    currency: "INR ",
    price: "360",
    mrp: "360",
    discount: "0% off",
  },
  {
    title: "Stag Manika Batra MS30 Table Tennis Bat",
    desc: "Stag Manika Batra MS30 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS30.jpg",
    currency: "INR ",
    price: "450",
    mrp: "450",
    discount: "0% off",
  },
  {
    title: "Stag Manika Batra MS40 Table Tennis Bat",
    desc: "Stag Manika Batra MS40 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS40.jpg",
    currency: "INR ",
    price: "550",
    mrp: "550",
    discount: "0% off",
  },
  {
    title: "Stag Manika Batra MS50 Table Tennis Bat",
    desc: "Stag Manika Batra MS50 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS50.jpg",
    currency: "INR ",
    price: "750",
    mrp: "675",
    discount: "10% off",
  },
  {
    title: "Stag Manika Batra MS3000 Table Tennis Bat",
    desc: "Stag Manika Batra MS3000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS3000.jpg",
    currency: "INR ",
    price: "1100",
    mrp: "950",
    discount: "14% off",
  },
  {
    title: "STAG Super Table Tennis Bat",
    desc: "STAG Super Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT330.jpg",
    currency: "INR ",
    price: "700",
    mrp: "600",
    discount: "14% off",
  },
  {
    title: "STAG International Table Tennis Bat (With Wooden Case)",
    desc: "\nHigh Quality Table Tennis Racquets. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT321_L.jpg",
    currency: "INR ",
    price: "1350",
    mrp: "1150",
    discount: "15% off",
  },
  {
    title: "STAG Power Drive Table Tennis Bat (With Wooden Case)",
    desc: "ITTF Approved Power Drive Rubber. ALL-ROUND Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT320_L.jpg",
    currency: "INR ",
    price: "1650",
    mrp: "1400",
    discount: "15% off",
  },
  {
    title: "DONIC Epox Off Sonex JP Gold Table Tennis Bat",
    desc: "DONIC Epox Off Sonex JP Gold Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DNDTBEOSJG.jpg",
    currency: "INR ",
    price: "10899",
    mrp: "8174",
    discount: "25% off",
  },
  {
    title: "Butterfly Timo Boll 2000 Table Tennis Bat",
    desc: "\nButterfly Timo Boll 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTB2000L.jpg",
    currency: "INR ",
    price: "2390",
    mrp: "1999",
    discount: "16% off",
  },
  {
    title: "Butterfly Addoy 2000 Table Tennis Bat",
    desc: "\nButterfly Addoy 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTA2000L.jpg",
    currency: "INR ",
    price: "1580",
    mrp: "1349",
    discount: "15% off",
  },
  {
    title: "DONIC Waldner 3000 Table Tennis Bat",
    desc: "\nLevel 3000 attack+ racket. Flared (FL) handle. Inverted Liga rubber with 2.3 mm sponge. Carbon blade featuring ABP (Adjustable Balance Point) and Ergo Grip. ITTF approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DNTTBTWL3K.jpg",
    currency: "INR ",
    price: "4549",
    mrp: "3649",
    discount: "20% off",
  },
  {
    title: "Nittaku Brave 300 Table Tennis Bat",
    desc: "\nNittaku Brave 300 is designed for Perfect Control with Speed. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "825",
    mrp: "619",
    discount: "25% off",
  },
  {
    title: "Nittaku Brave 100 Table Tennis Bat",
    desc: "\nNittaku Brave 100 is designed for Control with Speed. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "725",
    mrp: "544",
    discount: "25% off",
  },
  {
    title: "STAG One Star Play Table Tennis Bat Set",
    desc: "\nPlay Set: 2 Bats , 3 Balls ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "520",
    mrp: "475",
    discount: "9% off",
  },
  {
    title: "STAG 1 Star Table Tennis Bat",
    desc: "Racquet for Fun Play and Beginners. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT351_L.jpg",
    currency: "INR ",
    price: "200",
    mrp: "200",
    discount: "0% off",
  },
  {
    title: "STAG Play Table Tennis Bat Set",
    desc: "Play Set: 2 Bats , 3 Balls, PVC Net ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT328.jpg",
    currency: "INR ",
    price: "650",
    mrp: "575",
    discount: "12% off",
  },
  {
    title: "STAG 3 Star Table Tennis Bat",
    desc: "Racquet for School level players. Good all round racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT353_L.jpg",
    currency: "INR ",
    price: "520",
    mrp: "475",
    discount: "9% off",
  },
  {
    title: "STAG 2 Star Table Tennis Bat",
    desc: "Racquet for Beginners. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT352_L.jpg",
    currency: "INR ",
    price: "275",
    mrp: "275",
    discount: "0% off",
  },
  {
    title: "STAG 4 Star Table Tennis Bat",
    desc: "Racquet for School level players. Excellent control, fast racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT354_L.jpg",
    currency: "INR ",
    price: "575",
    mrp: "525",
    discount: "9% off",
  },
  {
    title: "STAG Club Table Tennis Bat",
    desc: "Good Control Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT325_L.jpg",
    currency: "INR ",
    price: "350",
    mrp: "325",
    discount: "7% off",
  },
  {
    title: "STAG 5 Star Table Tennis Bat",
    desc: "\nIdeal racquet for serious learners who want to play competitive table tennis. Fast racquet with very good Spin. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT355_L.jpg",
    currency: "INR ",
    price: "775",
    mrp: "650",
    discount: "16% off",
  },
  {
    title: "STAG Official Table Tennis Bat",
    desc: "\nGood Control Racquet. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT323_M1.jpg",
    currency: "INR ",
    price: "900",
    mrp: "800",
    discount: "11% off",
  },
  {
    title: "STAG Tourtitlent Table Tennis Bat",
    desc: "\nGood Control Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT324_L.jpg",
    currency: "INR ",
    price: "475",
    mrp: "425",
    discount: "11% off",
  },
  {
    title: "STAG Championship Table Tennis Bat",
    desc: "\nHigh Quality Table Tennis Racquets. ITTF Approved. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1100",
    mrp: "925",
    discount: "16% off",
  },
  {
    title: "STAG Ninja Attack Table Tennis Bat",
    desc: "ITTF Approved Ninja Attack Rubber. Excellent Spin. ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1950",
    mrp: "1650",
    discount: "15% off",
  },
  {
    title: "STAG All Round Table Tennis Bat",
    desc: "\nITTF Approved Rubber. Perfect racquet for All-round play! ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "2300",
    mrp: "1950",
    discount: "15% off",
  },
  {
    title: "STAG Ninja Fire Table Tennis Bat",
    desc: "ITTF Approved. Excellent Racquet for very fast shots & great spin! ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "2500",
    mrp: "2125",
    discount: "15% off",
  },
  {
    title: "DONIC Waldner 400 Table Tennis Bat",
    desc: "\nWaldner 400: For an allround game with outstanding control ! Elite 1 Star ITTF approved reversed rubber . Flared handle and with 1.8 mm Donic red and black rubber sheets. With Anti Vibration System. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W400_L.jpg",
    currency: "INR ",
    price: "649",
    mrp: "599",
    discount: "8% off",
  },
  {
    title: "DONIC Waldner 1000 Table Tennis Bat",
    desc: "\nTop of the line Carbon racquet !\nA 3-ply wood and 2 Ply carbon and Adjustable Balance Point in the handle. Comes with 2.1 mm Liga red and black rubber (ITTF approved).  ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W1000_L.jpg",
    currency: "INR ",
    price: "3449",
    mrp: "2749",
    discount: "20% off",
  },
  {
    title: "DONIC Waldner 800 Table Tennis Bat",
    desc: "\nWaldner 800: Allows sophisticated play with optimum speed and relatively high spin! \nA very controlled ITTF-approved rubber sheet with a 5-ply allround plywood and a Senso grip and 2.1 mm Alpha Slick rubber gives you a superior feeling for the ball in all playing situations.  ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "2229",
    mrp: "1675",
    discount: "25% off",
  },
  {
    title: "DONIC Waldner 700 Table Tennis Bat",
    desc: "\nWaldner 700: For advanced playing techniques with very good spin and speed! With concave handle and with Vari Slick 2.0 mm rubber (ITTF approved). ",
    img: "https://martjackassets.blob.core.windows.net/css/storeui/images/show_loader.gif",
    currency: "INR ",
    price: "1729",
    mrp: "1375",
    discount: "20% off",
  },
  {
    title: "DONIC Waldner 600 Table Tennis Bat",
    desc: "\nWaldner 600: Controllable All-round racquet comes with 2.0 mm soft red and black rubber with 5-plywood. Avantgarde 3 Star reversed rubber (ITTF approved). ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W600_L.jpg",
    currency: "INR ",
    price: "1179",
    mrp: "1000",
    discount: "15% off",
  },
  {
    title: "DONIC Waldner 500 Table Tennis Bat",
    desc: "\nWaldner 500: Controllable All-round rubber. The racquet comes with 1.8 mm soft red and black 2 star rubber in combination with the 5-ply allround plywood.\nWith Power Light System. Suitable for advanced play with good ball control. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W500_L.jpg",
    currency: "INR ",
    price: "829",
    mrp: "750",
    discount: "10% off",
  },
  {
    title: "DONIC Waldner 900 Table Tennis Bat",
    desc: "\nAllows sophisticated play with optimum speed and relatively high spin! \nA 5-ply wood which comes with 2.1 mm red and black Easy Slick rubber and a Flared handle. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/W900_L.jpg",
    currency: "INR ",
    price: "2999",
    mrp: "2249",
    discount: "25% off",
  },
  {
    title: "Stiga Elite Table Tennis Bat",
    desc: "The ELITE combines spin and speed characteristics for the serious player.Â WRB technology provides extra sensitivity and more power.Â Â WRB Patented System.Â Â I.T.T.F. Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STTTBTEL.jpg",
    currency: "INR ",
    price: "940",
    mrp: "752",
    discount: "20% off",
  },
  {
    title: "STAG Power Drive Table Tennis Bat",
    desc: "ITTF Approved Power Drive Rubber. ALL-ROUND Racquet. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT320_L.jpg",
    currency: "INR ",
    price: "1450",
    mrp: "1225",
    discount: "16% off",
  },
  {
    title: "STAG International Table Tennis Bat",
    desc: "\nHigh Quality Table Tennis Racquets. ITTF Approved. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBT321_L.jpg",
    currency: "INR ",
    price: "1150",
    mrp: "975",
    discount: "15% off",
  },
  {
    title: "DONIC Gold Attack Table Tennis Bat",
    desc: "\nGOLD Attack: Endorsed by Jan-Ove Waldner. For the sophisticated play of all techniques with spin and high speed.\nWith shock absorbing layers, AVS offers less vibration and more control. ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/GOLD_L.jpg",
    currency: "INR ",
    price: "1379",
    mrp: "1249",
    discount: "9% off",
  },
  {
    title: "Butterfly Wakaba 20 With 2 Balls",
    desc: "Butterfly Wakaba 20 with 2 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTSTW20L.jpg",
    currency: "INR ",
    price: "2180",
    mrp: "1635",
    discount: "25% off",
  },
  {
    title: "Butterfly Stayer With 2 Balls",
    desc: "Butterfly Stayer with 2 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTSTSTL.jpg",
    currency: "INR ",
    price: "3721",
    mrp: "2605",
    discount: "30% off",
  },
  {
    title: "Butterfly Addoy 1000 Table Tennis Bat",
    desc: "Butterfly Addoy 1000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTA1000L.jpg",
    currency: "INR ",
    price: "1580",
    mrp: "1349",
    discount: "15% off",
  },
  {
    title: "Butterfly Wakaba 1000 Table Tennis Bat",
    desc: "\nButterfly Wakaba 1000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTWK1000L.jpg",
    currency: "INR ",
    price: "2240",
    mrp: "1899",
    discount: "15% off",
  },
  {
    title: "Butterfly Wakaba 2000 Table Tennis Bat",
    desc: "\nButterfly Wakaba 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTWK2000L.jpg",
    currency: "INR ",
    price: "2240",
    mrp: "1899",
    discount: "15% off",
  },
  {
    title: "Butterfly Timo Boll 1000 Table Tennis Bat",
    desc: "\nButterfly Timo Boll 1000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTB1000.jpg",
    currency: "INR ",
    price: "2390",
    mrp: "1999",
    discount: "16% off",
  },
  {
    title: "Butterfly Timo Boll CF 1000 Table Tennis Bat",
    desc: "\nButterfly Timo Boll CF 1000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTBCF1000L.jpg",
    currency: "INR ",
    price: "3820",
    mrp: "2675",
    discount: "30% off",
  },
  {
    title: "Butterfly Timo Boll CF 2000 Table Tennis Bat",
    desc: "Butterfly Timo Boll CF 2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTBCF2000L.jpg",
    currency: "INR ",
    price: "3820",
    mrp: "2675",
    discount: "30% off",
  },
  {
    title: "STAG Peter Fire Ninja Table Tennis Bat",
    desc: "STAG Peter Fire Ninja Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTPTFR.jpg",
    currency: "INR ",
    price: "5200",
    mrp: "4150",
    discount: "20% off",
  },
  {
    title: "Stag Manika Batra MS10 Table Tennis Bat",
    desc: "Stag Manika Batra MS10 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS10.jpg",
    currency: "INR ",
    price: "250",
    mrp: "250",
    discount: "0% off",
  },
  {
    title: "Stag Manika Batra MS2000 Table Tennis Bat",
    desc: "Stag Manika Batra MS2000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/STATTBTMS2000.jpg",
    currency: "INR ",
    price: "900",
    mrp: "810",
    discount: "10% off",
  },
  {
    title: "Donic Carbotec 7000 Table Tennis Bat",
    desc: "Donic Carbotec 7000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DOTTBAT758216.jpg",
    currency: "INR ",
    price: "5379",
    mrp: "4299",
    discount: "20% off",
  },
  {
    title: "Butterfly Stayer 1800 Table Tennis Bat",
    desc: "Butterfly Stayer 1800 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTST1800.jpg",
    currency: "INR ",
    price: "2570",
    mrp: "1799",
    discount: "30% off",
  },
  {
    title: "Butterfly Stayer 3000 Table Tennis Bat",
    desc: "Butterfly Stayer 3000 Table Tennis Bat ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTST3000.jpg",
    currency: "INR ",
    price: "2990",
    mrp: "2541",
    discount: "15% off",
  },
  {
    title: "Butterfly Timo Boll 3000 Table Tennis Bat With 2 Balls",
    desc: "Butterfly Timo Boll 3000 Table Tennis Bat with 2 Balls ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/BFTTBTTB3000W2B.jpg",
    currency: "INR ",
    price: "2390",
    mrp: "1999",
    discount: "16% off",
  },
];
